var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mission"
  }, [_c('box', {
    staticClass: "ombox",
    attrs: {
      "title": _vm.$k18n({
        id: 'k_333272'
      })
    }
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l(_vm.store.taskList, function (item, index) {
    var _item$extraInfo, _item$extraInfo2;

    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "top"
    }, [_c('p', {
      class: {
        text: true,
        line: item.type === _vm.TaskTypeEnum.OFFICIAL
      }
    }, [item.type === _vm.TaskTypeEnum.SHARE ? _c('i', [_vm._v(_vm._s(_vm.$k18n({
      id: item.text,
      params: {
        '0': item.point,
        '1': item.dateLimit
      }
    })))]) : item.type === _vm.TaskTypeEnum.OFFICIAL ? _c('i', [_vm._v(_vm._s(_vm.$k18n({
      id: item.text,
      params: {
        '0': item.point
      }
    })))]) : _c('i', [_vm._v(" " + _vm._s(_vm.$k18n({
      id: item.text,
      params: {
        '0': item.target,
        '1': item.point,
        '2': item.dateLimit
      }
    })) + " ")])]), item.type === _vm.TaskTypeEnum.SHARE ? [_c('span', {
      staticClass: "btn",
      on: {
        "click": _vm.goToApp
      }
    }, [_vm._v(" " + _vm._s(_vm.$k18n({
      id: item.btnText
    })) + " ")])] : [item.type !== _vm.TaskTypeEnum.OFFICIAL ? _c('span', {
      staticClass: "btn",
      on: {
        "click": _vm.goToApp
      }
    }, [_vm._v(" " + _vm._s(_vm.$k18n({
      id: item.btnText
    })) + " ")]) : _vm._e()]], 2), item.type === _vm.TaskTypeEnum.OFFICIAL && item.extraInfo ? _c('div', {
      staticClass: "botm"
    }, [_c('k-image', {
      attrs: {
        "src": (_item$extraInfo = item.extraInfo) === null || _item$extraInfo === void 0 ? void 0 : _item$extraInfo.avatar,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "txt"
    }, [_c('p', {
      staticClass: "t"
    }, [_vm._v(_vm._s((_item$extraInfo2 = item.extraInfo) === null || _item$extraInfo2 === void 0 ? void 0 : _item$extraInfo2.name))]), _c('p', {
      staticClass: "s"
    }, [_vm._v(_vm._s(_vm.$k18n({
      id: 'k_333291'
    })))])]), _c('div', {
      staticClass: "follow",
      on: {
        "click": _vm.goToApp
      }
    }, [_vm._v(" " + _vm._s(_vm.$k18n({
      id: item.btnText
    })) + " ")])], 1) : _vm._e(), item.type === _vm.TaskTypeEnum.SHARE && _vm.store.shareOpenedInfo ? _c('div', {
      staticClass: "share-open"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('p', {
      staticClass: "text line"
    }, [_vm._v(_vm._s(_vm.$k18n({
      id: 'k_333279',
      params: {
        '0': _vm.store.shareOpenedInfo.point
      }
    })))])])]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "outbtn",
    on: {
      "click": _vm.goToApp
    }
  }, [_vm._v(" " + _vm._s(_vm.$k18n({
    id: 'k_333218'
  })) + " ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }